///<reference path='../../typings/index.d.ts' />
///<reference path='pixilayer.ts' />

module agi.expressions.card.layer {

    import Event = agi.expressions.event.Event;
    import AssetManifest = agi.expressions.card.manifest.AssetManifest;
    import MovieClip = PIXI.extras.MovieClip;

    export class EndScene extends PixiLayer{
        private renderer:PIXI.WebGLRenderer|PIXI.CanvasRenderer;
        private assetManifest:AssetManifest;
        private bg:PIXI.Sprite;
        private tree:PIXI.Sprite;
        private copy:PIXI.Sprite;

        private pumpkinContainer:PIXI.Container;
        private pumpkin:PIXI.Sprite;
        private pumpkinInside:PIXI.Sprite;
        private pumpkinDark:PIXI.Sprite;
        private pumpkinCandle:PIXI.Sprite;
        private pumpkinLeaves:PIXI.Sprite;
        private pumpkinSparkles:PIXI.Container;

        private carveContainer:PIXI.Container;
        private carveCake:PIXI.Sprite;
        private carveButterfly:PIXI.Sprite;
        private carveCat:PIXI.Sprite;
        private carveFace:PIXI.Sprite;
        private carveHouse:PIXI.Sprite;
        private carveSpider:PIXI.Sprite;
        private carvePresent:PIXI.Sprite;
        private carveArray:Array<PIXI.Sprite>=[];
        private currentCarve:number=0;
        private flickering:boolean=false;
        private carveComplete:boolean=true;

        private firefly1:PIXI.Sprite;
        private firefly2:PIXI.Sprite;
        private firefly3:PIXI.Sprite;
        private firefly4:PIXI.Sprite;
        private firefly5:PIXI.Sprite;
        private firefly6:PIXI.Sprite;
        private firefly7:PIXI.Sprite;
        private firefly8:PIXI.Sprite;
        private firefly9:PIXI.Sprite;
        private firefly10:PIXI.Sprite;
        private firefly11:PIXI.Sprite;
        private firefly12:PIXI.Sprite;

        private batClip1:PIXI.extras.MovieClip;
        private batClip2:PIXI.extras.MovieClip;
        private batClip3:PIXI.extras.MovieClip;

        private magicClip:PIXI.extras.MovieClip;

        private previewButton:PIXI.Sprite;
        private replayButton:PIXI.Sprite;
        private tapPumpkin:PIXI.Sprite;
        private replaying:boolean = false;

        constructor(){
            super();
        }

        public init(options:SceneOptions){
            this.renderer = options.renderer;         
            this.assetManifest = options.assetManifest;
            this.bg = PIXI.Sprite.fromFrame("bg_landscape.png");
            this.addChild(this.bg);
            //bats
            this.batClip1=this.movieClipBuilder(this.assetManifest.bat,0.42);
            this.batClip2=this.movieClipBuilder(this.assetManifest.bat,0.42);
            this.batClip3=this.movieClipBuilder(this.assetManifest.bat,0.42);
            this.batClip3.pivot.set(51,45);
            this.batClip1.pivot=this.batClip2.pivot=this.batClip3.pivot;
            this.batClip1.position.set(-100,205);
            this.batClip1.scale.set(0.4,0.4);
            this.batClip2.position.set(-100,372);
            this.batClip2.scale.set(0.2,0.2);
            this.batClip3.position.set(-100,185);
            this.batClip3.scale.set(0.1,0.1);

            //big bat flies straight
            TweenMax.to(this.batClip1,4.5,{x:650,y:-5,repeat:-1,ease:Linear.easeNone,repeatDelay:5,delay:4});            
            TweenMax.to(this.batClip1.scale,4.5,{x:0.8,y:0.8,repeat:-1,ease:Linear.easeNone,repeatDelay:5,delay:4});
            //small bats are wavy
            TweenMax.to(this.batClip2,4.5,{bezier:[{x:-100, y:372}, {x:140, y:156}, {x:290, y:180}, {x:650, y:26}],repeat:-1,ease:Linear.easeNone,repeatDelay:5,delay:4});
            TweenMax.to(this.batClip2.scale,4.5,{x:0.6,y:0.6,repeat:-1,ease:Linear.easeNone,repeatDelay:5,delay:4});
            
            TweenMax.to(this.batClip3,4.5,{bezier:[{x:-100, y:300}, {x:150, y:115}, {x:470, y:160}, {x:650, y:108}],repeat:-1,ease:Linear.easeNone,repeatDelay:5,delay:4});
            TweenMax.to(this.batClip3.scale,4.5,{x:0.5,y:0.5,repeat:-1,ease:Linear.easeNone,repeatDelay:5,delay:4});

            this.batClip1.gotoAndPlay(1);
            this.batClip2.gotoAndPlay(3);
            this.batClip3.gotoAndPlay(0);
            this.addChild(this.batClip1);
            this.addChild(this.batClip2);
            this.addChild(this.batClip3);

            this.tree = PIXI.Sprite.fromFrame("tree.png");
            this.addChild(this.tree);

            //Halloween tag
            this.copy=PIXI.Sprite.fromFrame(this.assetManifest.ui.copy);
            this.copy.y=10;
            this.addChild(this.copy);
            
            //fireflies, behind the pumpkin (ooh, depth)
            this.fireflyMaker(this.firefly10,0.3,215,300,310,350,5,5,2.3333);
            this.fireflyMaker(this.firefly11,0.4,420,310,540,250,4,5,3.333);
            this.fireflyMaker(this.firefly12,0.2,465,345,560,435,6.1,4.21,1.43);

            //pumpkin
            this.currentCarve=0;
            this.pumpkinContainer=new PIXI.Container();
            this.carveContainer=new PIXI.Container();
            this.pumpkinSparkles=new PIXI.Container();
            this.pumpkin = PIXI.Sprite.fromFrame(this.assetManifest.pumpkin.pumpkin);
            this.pumpkinCandle=PIXI.Sprite.fromFrame(this.assetManifest.pumpkin.candle);
            this.pumpkinInside=PIXI.Sprite.fromFrame(this.assetManifest.pumpkin.inside);
            this.pumpkinDark=PIXI.Sprite.fromFrame(this.assetManifest.pumpkin.dark);
            this.carveContainer.addChild(this.pumpkinInside);
            this.carveContainer.addChild(this.pumpkinDark);
            this.carveContainer.addChild(this.pumpkinCandle);
            this.flickering=false;

            this.carveCake=PIXI.Sprite.fromFrame(this.assetManifest.carve.cake);
            this.carveButterfly=PIXI.Sprite.fromFrame(this.assetManifest.carve.butterfly);
            this.carveCat=PIXI.Sprite.fromFrame(this.assetManifest.carve.cat);
            this.carveFace=PIXI.Sprite.fromFrame(this.assetManifest.carve.face);
            this.carveHouse=PIXI.Sprite.fromFrame(this.assetManifest.carve.house);
            this.carveSpider=PIXI.Sprite.fromFrame(this.assetManifest.carve.spider);
            this.carvePresent=PIXI.Sprite.fromFrame(this.assetManifest.carve.present);

            this.carveArray=[this.carveCake,this.carvePresent,this.carveButterfly,this.carveCat,this.carveFace,this.carveHouse,this.carveSpider];

            for(var i=0;i<this.carveArray.length;i++){
                this.carveArray[i].visible=false;
                this.carveContainer.addChild(this.carveArray[i]);
            }

            this.pumpkinContainer.addChild(this.pumpkin);
            this.pumpkinContainer.addChild(this.carveContainer);
            this.pumpkinContainer.addChild(this.pumpkinSparkles);
            this.carveContainer.visible=false;

            this.tapPumpkin = PIXI.Sprite.fromFrame(this.assetManifest.ui.tapPumpkin);
            this.tapPumpkin.position.set(70,129);
            this.pumpkinContainer.addChild(this.tapPumpkin);

            this.pumpkinContainer.interactive=true;
            this.pumpkinContainer.buttonMode=true;
            this.pumpkinContainer.hitArea=new PIXI.Rectangle(10,73,265,180);
            this.pumpkinContainer.on('touchend', this.carvePumpkin.bind(this), this);
            this.pumpkinContainer.on('mousedown', this.carvePumpkin.bind(this), this);

            //magic explosion
            this.magicClip=this.movieClipBuilder(this.assetManifest.magic,0.42);
            this.magicClip.position.set(-5,0);
            //this.magicClip.blendMode=PIXI.BLEND_MODES.ADD;
            this.magicClip.loop=false;
            this.magicClip.gotoAndStop(7);
            this.pumpkinContainer.addChild(this.magicClip);

            this.pumpkinLeaves=PIXI.Sprite.fromFrame(this.assetManifest.pumpkin.leaves);
            this.pumpkinLeaves.position.set(-58,117);
            this.pumpkinContainer.addChild(this.pumpkinLeaves);

            this.addChild(this.pumpkinContainer);
            this.pumpkinContainer.position.set(215,224);

            //fireflies
            this.fireflyMaker(this.firefly1,1.0,100,500,25,450,4,5,2);
            this.fireflyMaker(this.firefly2,0.5,30,440,100,500,5,4,1.5);
            this.fireflyMaker(this.firefly3,0.7,80,420,10,380,6,5.5,2.2);

            this.fireflyMaker(this.firefly4,1.0,515,425,540,512,3.4,5.7,3);
            this.fireflyMaker(this.firefly5,0.5,480,480,380,530,4,5,1.8);
            this.fireflyMaker(this.firefly6,0.7,530,530,460,450,4.3,6.3,2.5);

            this.fireflyMaker(this.firefly7,1.0,180,468,265,500,4.2,4.1,1.9);
            this.fireflyMaker(this.firefly8,0.5,300,450,440,500,4,5,2.4);
            this.fireflyMaker(this.firefly9,0.7,150,460,255,430,5.2,3.7,1.75);

            this.addButtons();

            this.eventBus.addEventListener("revealReset", this.resetReplayButton.bind(this));
        }

        public fireflyMaker(aSprite:PIXI.Sprite,scale:number,xPos:number,yPos:number,xMax:number,yMax:number,xTime:number,yTime:number,alphaTime:number){
            aSprite=PIXI.Sprite.fromFrame("firefly.png");
            aSprite.pivot.set(42,42);
            aSprite.scale.set(scale,scale);
            aSprite.position.set(xPos,yPos);
            TweenMax.to(aSprite,xTime,{x:xMax,ease:Power2.easeInOut,repeat:-1,yoyo:true});
            TweenMax.to(aSprite,yTime,{y:yMax,ease:Power2.easeInOut,repeat:-1,yoyo:true});
            TweenMax.to(aSprite,alphaTime,{alpha:0,ease:Circ.easeInOut,repeat:-1,yoyo:true});
            this.addChild(aSprite);
        }

        public reset(){
            this.visible = true;
        }

        public animate(deltaTime?:number){
            if(!this.isPlaying){
                this.isPlaying=true;
            }else{
                // flicker the lights in glowContainer.
                if(!this.flickering){
                    this.flickering=true;
                    var newGlow:number= Math.random()*0.7;
                    // tween glow container to new opacity
                    TweenMax.to(this.pumpkinDark,Math.random()*0.35,{alpha:newGlow,onComplete:this.flickerDone,onCompleteScope:this});
                    TweenMax.to(this.pumpkinCandle,Math.random()*0.35,{alpha:1-newGlow,onComplete:this.flickerDone,onCompleteScope:this});
                }
            }
        }

        protected flickerDone(){
            this.flickering= false;
        }

        private addButtons() {
            this.replayButton = PIXI.Sprite.fromFrame(this.assetManifest.ui.replayButton);
            this.replayButton.interactive = true;
            this.replayButton.buttonMode = true;
            this.replayButton.on('touchend', this.replayButtonHandler.bind(this), this);
            this.replayButton.on('mousedown', this.replayButtonHandler.bind(this), this);
            this.replayButton.visible = true;
            this.replayButton.x = 218;
            this.replayButton.y = 490;
            this.addChild(this.replayButton);
        }

        private replayButtonHandler(event:Event) {
            if (!this.replaying){
                this.replaying = true;
                var replayEvent:Event = new Event("replay", this);
                this.eventBus.dispatchEvent(replayEvent);
            }
        }

        private resetReplayButton(event:Event) {
            this.replaying = false;
        }

        private movieClipBuilder(spriteArray:Array<string>,speed:number):PIXI.extras.MovieClip{
            var textureArray = [];
            for(var i=0;i<spriteArray.length;i++){
                var aTex:PIXI.Texture=PIXI.Texture.fromFrame(spriteArray[i]);
                textureArray.push(aTex);
            }
            var mc = new PIXI.extras.MovieClip(textureArray);
            mc.animationSpeed=speed;
            return mc;
        }

        private carvePumpkin(){
            if(this.carveComplete){
                this.carveComplete=false;
                this.tapPumpkin.alpha=0;
                this.carveContainer.visible=true;
                this.carveContainer.alpha=1;
                this.carveContainer.cacheAsBitmap=false;
                //show the next carving in sequence
                for(var i=0;i<this.carveArray.length;i++){
                    this.carveArray[i].visible=false;
                    //this.carveArray[i].alpha=0;
                }
                this.carveArray[this.currentCarve].visible=true;
                
                TweenMax.to(this,0.3,{onUpdate:this.bitmapTween,onUpdateScope:this,onComplete:this.handleCarveComplete,onCompleteScope:this})

                this.currentCarve++;
                if(this.currentCarve>=this.carveArray.length){
                    this.currentCarve=0;
                }
                TweenMax.killTweensOf(this.carveContainer);
                TweenMax.killTweensOf(this.tapPumpkin);                
                TweenMax.to(this.carveContainer,1,{alpha:0,delay:4,onUpdate:this.bitmapTween,onUpdateScope:this});            
                TweenMax.to(this.tapPumpkin,1,{alpha:1,delay:4});

                //make some sparkle
                for(var i=0;i<40;i++){
                    var newSparkle=PIXI.Sprite.fromFrame('firefly.png');
                    //find a random point in a circle
                    var xPos=Math.random()+0.2;
                    var yPos=Math.random()+0.2;
                    var scalePos=Math.random();
                    newSparkle.x=142+yPos*142*Math.cos(2*Math.PI*xPos/yPos);
                    newSparkle.y=163+yPos*100*Math.sin(2*Math.PI*xPos/yPos);
                    //newSparkle.x=142+(Math.random()*246)-123;
                    //newSparkle.y=163+(Math.random()*176)-88;
                    newSparkle.scale.set(0.5*scalePos,0.5*scalePos);
                    newSparkle.blendMode=PIXI.BLEND_MODES.ADD;
                    TweenLite.to(newSparkle,1.5,{width:0, height:0, onComplete:this.sparkleRemove,onCompleteParams:[newSparkle],onCompleteScope:this});
                    TweenLite.to(newSparkle,1.5,{x:142+yPos*300*Math.cos(2*Math.PI*xPos/yPos),y:163+yPos*200*Math.sin(2*Math.PI*xPos/yPos)});
                    this.pumpkinSparkles.addChild(newSparkle);
                }
                //play magic explosion
                this.magicClip.gotoAndPlay(0);    
                
                //event bus
                var carveEvent:Event = new Event("carve", this);
                this.eventBus.dispatchEvent(carveEvent);

                var carveSoundEffect:any = new Event("playSFX", this);
                carveSoundEffect.sfx = "sfx2";
                this.eventBus.dispatchEvent(carveSoundEffect);
            }
        }

        public handleCarveComplete(){
            this.carveComplete=true;
            this.carveContainer.cacheAsBitmap=false;
        }

        public sparkleRemove(aSparkle){
            this.pumpkinSparkles.removeChild(aSparkle);
        }

        //if we don't cache as bitmap during the tween, ALL layers of carve container get alpha-ed.
        //this means we can briefly see inside of the pumpkin... looks wrong.
        public bitmapTween(){
            this.carveContainer.cacheAsBitmap=true;
        }
    }
}
